// Centralized data-testid registry for The Intuitus Hub™

export const NAV = {
    logo: "nav-logo",
    home: "nav-home",
    about: "nav-about",
    framework: "nav-framework",
    snapshot: "nav-snapshot",
    foundations: "nav-foundations",
    resources: "nav-resources",
    discovery: "nav-discovery",
    contact: "nav-contact",
    cta: "nav-cta-snapshot",
    mobileToggle: "nav-mobile-toggle",
};

export const FOOTER = {
    root: "site-footer",
    snapshotCta: "footer-cta-snapshot",
    discoveryCta: "footer-cta-discovery",
    contactCta: "footer-cta-contact",
};

export const HOME = {
    heroTitle: "home-hero-title",
    heroCta: "home-hero-cta-snapshot",
    heroSecondaryCta: "home-hero-cta-framework",
    introHub: "home-intro-hub",
    introFramework: "home-intro-framework",
    pillarsGrid: "home-pillars-grid",
    bottomCta: "home-bottom-cta",
};

export const ABOUT = {
    page: "about-page",
    missionCta: "about-cta-snapshot",
};

export const FRAMEWORK = {
    page: "framework-page",
    pillar: (slug) => `framework-pillar-${slug}`,
    cta: "framework-cta-snapshot",
};

export const COMING = {
    page: (slug) => `coming-soon-${slug}`,
    back: "coming-soon-back",
};
